import React from "react";
import { Sparkles } from "lucide-react";

export default function ComingSoon({ title }) {
  return (
    <div data-testid="coming-soon" className="px-6 py-10">
      <div className="mx-auto max-w-2xl rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-card">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#EFF6FF] text-[#2563EB]">
          <Sparkles size={20} />
        </div>
        <h2 data-testid="coming-soon-title" className="text-[18px] font-bold text-[#1E3A5F]">
          {title}
        </h2>
        <p className="mt-2 text-[13px] text-slate-500">
          This module is under construction. We're shipping it next — once Executive Overview is fully tested.
        </p>
        <div className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1 text-[11px] font-medium text-amber-700">
          Coming soon
        </div>
      </div>
    </div>
  );
}
